import React from "react";
import SingleFlightLegContent from "../components/flightLegs/single-flightLeg-content";

const SingleFlightLeg = () => {
  return <SingleFlightLegContent />;
};

export default SingleFlightLeg;
